import React from 'react';
import { Helmet } from 'react-helmet';

const TermsOfService = () => {
  return (
    <div className="legal-container">
      <Helmet>
        <title>Conditions Générales - MulByte</title>
        <meta name="description" content="Conditions d'utilisation des services MulByte" />
      </Helmet>

      <h1>Conditions Générales d'Utilisation</h1>
      <p className="last-updated">En vigueur depuis : {new Date().toLocaleDateString('fr-FR')}</p>

      <section>
        <h2>1. Objet</h2>
        <p>
          Ces CGU régissent l'utilisation des services de MulByte (développement web, applications mobiles).
        </p>
      </section>

      <section>
        <h2>2. Acceptation</h2>
        <p>
          Toute commande implique l'acceptation <strong>expresse</strong> de ces CGU.
        </p>
      </section>

      {/* Ajoutez toutes les autres sections ici */}

      <section>
        <h2>9. Litiges</h2>
        <p>
          Juridiction compétente : Tribunal de Commerce de Kinshasa, RDC.
        </p>
      </section>
    </div>
  );
};

export default TermsOfService;